export default __webpack_public_path__ + "static/media/une (4).68094ce9.jpg";